import React from 'react';
import { User, Settings, Key, Bell, CreditCard, Shield, Thermometer } from 'lucide-react';

interface SettingsTabsListProps {
  selectedTab: string;
  onTabChange: (tab: string) => void;
  isAdmin?: boolean;
}

interface TabItem {
  id: string;
  name: string;
  icon: React.ReactNode;
  adminOnly?: boolean;
}

export default function SettingsTabsList({ selectedTab, onTabChange, isAdmin = false }: SettingsTabsListProps) {
  const tabs: TabItem[] = [
    {
      id: 'profile',
      name: 'Profile',
      icon: <User size={18} />
    },
    {
      id: 'preferences',
      name: 'Preferences',
      icon: <Settings size={18} />
    },
    {
      id: 'api-keys',
      name: 'API Keys',
      icon: <Key size={18} />
    },
    {
      id: 'notifications',
      name: 'Notifications',
      icon: <Bell size={18} />
    },
    {
      id: 'credits',
      name: 'Credits',
      icon: <CreditCard size={18} />
    },
    {
      id: 'llm-controls',
      name: 'LLM Controls',
      icon: <Thermometer size={18} />,
      adminOnly: true
    },
    {
      id: 'admin',
      name: 'Admin',
      icon: <Shield size={18} />,
      adminOnly: true
    }
  ];

  // Filter tabs based on admin access
  const visibleTabs = tabs.filter(tab => !tab.adminOnly || isAdmin);

  return (
    <div className="space-y-1">
      <h3 className="text-sm font-medium text-stewie-coolGray mb-3">Settings</h3>
      <nav className="space-y-1.5">
        {visibleTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`w-full flex items-center gap-3 px-3 py-2 text-sm rounded-md transition-colors ${
              selectedTab === tab.id
                ? 'bg-stewie-accent/20 text-white'
                : 'text-stewie-gray hover:bg-stewie-charcoal hover:text-white'
            }`}
          >
            <span className={selectedTab === tab.id ? 'text-stewie-accent' : 'text-stewie-gray'}>
              {tab.icon}
            </span>
            <span>{tab.name}</span>
            
            {tab.id === 'credits' && (
              <span className="ml-auto bg-stewie-blue/20 text-stewie-blue text-xs px-2 py-0.5 rounded-full">
                New
              </span>
            )}
            
            {tab.adminOnly && (
              <span className="ml-auto bg-red-500/20 text-red-400 text-xs px-2 py-0.5 rounded-full">
                Admin
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
}
